{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".testimonailsSlider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.3,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.1,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 25,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Blog_Sliders");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.3,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 2.7,
              spaceBetween: 25,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
